

export default function TextArea({ value, onChange, placeholder, readOnly, numOfRows = 5, labelIcon, labelText,error,isRequired,className }) {
    return (
        <div className={`mt-6 bg-white rounded-lg p-5 border border-gray-100 shadow-[0_2px_8px_rgba(0,0,0,0.08)] ${className}`}   >

            <label className="flex items-center gap-2 text-base font-semibold text-gray-700 mb-3">
                {labelIcon}
                <span>{labelText}</span>
                {isRequired && <span className="text-red-500 text-base">*</span>}
            </label>
            {!readOnly ?
            <>
                <textarea
                    className="w-full p-3 text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-100 focus:ring-2 focus:ring-[#135e96] focus:border-[#135e96] transition-all duration-200 resize-none font-medium"
                    placeholder={placeholder || "Write any additional comments here..."}
                    rows={numOfRows}
                    // readOnly={readOnly}
                    value={value}
                    onChange={onChange}
                />
                {error&&
                <div className="mt-3 p-3 bg-red-50 border border-red-100 rounded-lg shadow-sm">
                                              <p className="text-red-600 text-sm font-medium">
                                                {error}
                                              </p>
                                            </div>
}
                                            </>
                :
                <p className="text-sm text-gray-800 leading-relaxed whitespace-pre-wrap bg-white p-3 rounded-lg border border-gray-100">
                    {value}
                </p>
            }
        </div>
    )
}
